{
  "load_failed": "Failed to load poll data",
  "not_enabled": "Course polls are not enabled for this club",
  "prompt": {
    "kicker": "Course poll",
    "title": "Give feedback about the course",
    "round_meta": "Round {{date}}",
    "boolean_true": "Yes",
    "boolean_false": "No",
    "scale_low": "Poor",
    "scale_high": "Excellent",
    "comment_label": "Comment (optional)",
    "comment_placeholder": "Tell us more...",
    "submit": "Submit",
    "skip": "Skip",
    "submitted": "Thank you for your feedback!",
    "submit_failed": "Failed to submit feedback"
  },
  "editor": {
    "page_title": "Course polls",
    "select_course": "Select course",
    "no_courses": "No courses",
    "course_section": "Course",
    "poll_section": "Poll",
    "chip_locked": "Locked",
    "responses_label": "responses",
    "questions_count_label": "questions",
    "edit_questions": "Edit questions",
    "locked_micro": "The questions locked when the first response arrived. Replace the poll if you want to change them.",
    "frequency_label": "Prompt frequency",
    "frequency": {
      "AFTER_EACH_ROUND": "After each round",
      "WEEKLY": "Once a week",
      "MONTHLY": "Once a month",
      "ANNUAL": "Once a year"
    },
    "questions_label": "Questions",
    "question_text_placeholder": "Write a question",
    "question_type_label": "Type",
    "question_type": {
      "BOOLEAN": "Yes/No",
      "SCALE": "Scale 1-5"
    },
    "add_question": "Add question",
    "remove_question": "Remove question",
    "move_up": "Move up",
    "move_down": "Move down",
    "fill_all_questions": "Write text for every question",
    "create_button": "Create poll",
    "save_button": "Save changes",
    "replace_button": "Replace poll",
    "replace_save_button": "Save new poll",
    "cancel_replace": "Cancel",
    "archive_button": "Archive poll",
    "locked_notice": "The poll has received responses, so its questions can no longer be edited. Replace the poll if you want to change the questions.",
    "no_active_poll": "This course has no active poll.",
    "created": "Poll created",
    "updated": "Poll updated",
    "replaced": "Poll replaced",
    "archived": "Poll archived",
    "archive_confirm_header": "Archive poll",
    "archive_confirm_button": "Archive",
    "archive_confirm_body": "Are you sure you want to archive the poll? The course will then have no active poll until you create a new one.",
    "response_count": "{{count}} responses",
    "status_active": "Active"
  },
  "results": {
    "title": "Results",
    "answered_yes": "Answered yes",
    "no_responses": "No responses",
    "average": "Average",
    "median": "Median",
    "distribution_title": "Distribution",
    "trend_title": "Monthly trend",
    "no_comments": "No comments"
  },
  "report": {
    "kicker": "Course poll · Results",
    "kicker_questions": "Course poll · Questions",
    "kicker_new": "Course poll · New poll",
    "period_label": "Period",
    "comments_stat": "comments",
    "overall_average": "overall average",
    "n_count": "n={{count}}",
    "med_tick": "Med {{value}}",
    "vs_month": "vs. {{month}}",
    "pp_value": "{{value}} pp",
    "yes_no_label": "yes / no",
    "open_feedback": "Open feedback",
    "comments_count": "{{count}} comments",
    "export_pdf": "Download PDF",
    "pdf_title": "Course Survey",
    "pdf_page": "Page {{page}} / {{pages}}"
  },
  "history": {
    "archive_section": "Archive",
    "empty": "No archived polls",
    "archived": "Archived"
  }
}
